import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment';
import { saveAs } from 'file-saver';
import { environment } from '../../environments/environment';
import { CapabilityEngineService } from '../capabilityEngine.service';
import { LandingComponent } from '../landing/landing.component';
import { NewTeamService } from '../new-team/new-team.service';
import { RedirectService } from '../redirect/redirect.service';
import { TeamProfileService } from './team-profile.service';
declare var $: any;

@Component({
    selector: 'app-team-profile',
    templateUrl: './team-profile.component.html',
    styleUrls: ['./team-profile.component.scss']
})
export class TeamProfileComponent implements OnInit {
    teamObj: any = {};
    teamName: any;
    teamId: any;
    subscriptionDetails: any = {};
    notificationEmails: any[] = [];
    notificationEmailsHazards: any[] = [];
    notificationEmailsError: boolean = false;
    notificationEmailsHazardsError: boolean = false;
    errMessage: string = '';
    workAreaError: Boolean = false;
    areas: any[] = [];
    teamFormEmailNotification: FormGroup;
    updatedDetails: any = {};
    originalUserDetails: any = {};
    temporaryEmailNotification: any[] = [];
    successMsg: Boolean = false;
    errorMsg: any;
    notificationEmailDuplicateError: Boolean = false;
    authType: any;
    // successMsgs: any;
    errMsg: any;
    oldTeamObj: any = {};
    status: any;
    subscribeObj: any;
    invoiceObjdetail;
    invoiceObjdetails;
    subscribeValues: any;
    invoiceDwdUrl: any;
    // imageChangedEvent: any = '';
    // croppedImage: any = '';
    // saveImages: any;
    // ImageCroppedEvent: any;
    inspectionNotificationEmails: any = [];
    inspectionNotificationEmailDuplicateError: boolean = false;
    inspectionNotificationEmailsError: boolean = false;

    weeklyNotificationEmails: any = [];
    weeklyNotificationEmailDuplicateError: boolean = false;
    weeklyNotificationEmailsError: boolean = false;

    constructor(
        private _teamProfileService: TeamProfileService,
        private _activatedRoute: ActivatedRoute,
        private _capabilityEngineService: CapabilityEngineService,
        private _redirectService: RedirectService,
        private _newTeamService: NewTeamService,
        private _formBuilder: FormBuilder,
        private _landingComponent: LandingComponent,
        private _router: Router
    ) { }
    ngOnInit() {

        this.invoiceDwdUrl = environment.serverUrl + '/payment/subscriptions/invoice?id='
        // console.log('ngOnInit');
        const pathData = this._activatedRoute.data['_value'];
        if (this.canPerform(pathData.capabilities)) {

            this.teamObj.admins = [];
            console.log(this.teamObj.admins);
            this.teamId = localStorage.getItem('teamId');
            this.teamName = localStorage.getItem('teamName');
            console.log(this._activatedRoute.snapshot.params.id);

            this._teamProfileService.getTeamDetails(this.teamId).subscribe(
                (result: any) => {
                    console.log('teamobj', result);
                    let notificationEmails = [];
                    // let notificationEmailsHazards = [];
                    this.teamObj = result.data;
                    this.oldTeamObj = Object.assign(
                        this.oldTeamObj,
                        result.data
                    );
                    this.teamObj.validUpto = moment(this.teamObj.validUpto).format(
                        'MMM DD, YYYY'
                    );
                    // console.log(this.teamObj);
                    _.forEach(this.teamObj.notificationEmails, function (value) {
                        notificationEmails.push({ displayValue: value });
                    });
                    this.notificationEmails = notificationEmails;

                    
                    if(this.teamObj.preferences && this.teamObj.preferences.notifications && this.teamObj.preferences.notifications.length) {
                        let inspectionNotificationEmails = []
                        let index = _.findIndex(this.teamObj.preferences.notifications, (notification: any) => {
                            return notification.applyTo == "INSPECTION"
                        })

                        if(index != -1) {
                            _.forEach(this.teamObj.preferences.notifications[index]['emails'], function (value) {
                                inspectionNotificationEmails.push({ displayValue: value });
                            });
                            this.inspectionNotificationEmails = inspectionNotificationEmails;
                        }
                        // Weekly notifications
                        let weeklyNotificationEmails = []
                        
                        let weeklyIndex = _.findIndex(this.teamObj.preferences.notifications, (notification: any) => {
                            return notification.applyTo == "WEEKLY"
                        })

                        if(weeklyIndex != -1) {
                            _.forEach(this.teamObj.preferences.notifications[weeklyIndex]['emails'], function (value) {
                                weeklyNotificationEmails.push({ displayValue: value });
                            });
                            this.weeklyNotificationEmails = weeklyNotificationEmails;
                        }
                    }
                    

                    console.log('licence purchased', this.teamObj.licenses);
                    this.authType = this.teamObj.authentication.authDetails.authType;
                    // console.log(this.originalUserDetails);
                    // this.successMsg = 'The changes are successfully updated';
                },
                (err: any) => {
                    console.log('err ', err);
                }
            );

            this.teamFormEmailNotification = this._formBuilder.group({
                name: ['', [Validators.required, Validators.pattern(/.*[^ ].*/)]],
                contact: [
                    '',
                    [
                        Validators.maxLength(15),
                        Validators.pattern(/^\+[1-9]{1}[0-9]{3,14}$/)
                    ]
                ],
                // tslint:disable-next-line:max-line-length
                websiteReferenceUrl: [
                    '',
                    [
                        Validators.pattern(
                            /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
                        )
                    ]
                ],
                validUpto: ['', [Validators.required]],
                admins: this._formBuilder.array([]),
                areas: [[], [Validators.maxLength(50)]],
                notificationEmails: [[]],
                notificationEmailsHazards: [[]]
            });
        }
    }

    canPerform(data) {
        return this._capabilityEngineService.canPerform(data);
    }
    subscriptionDetail() {
        let subscriptionValues = {
            product: environment.APP_NAME,
            plan: environment.RECURLY_PLAN_CODE,
            users: this.teamObj.membersCount
        }
        this._teamProfileService.subscription(subscriptionValues)
            .subscribe((result: any) => {
                if (result.redirectUrl) {
                    var redirectUrl = result.redirectUrl;
                    window.open(redirectUrl, "_self");
                }
            })
    }

    subscribedDetail() {
        this._teamProfileService.subscribedDetails().subscribe(
            (res) => {
                this.subscribeValues = res;
                this.subscribeObj = this.subscribeValues.data;
                console.log(this.subscribeObj);
                if (this.subscribeObj.length > 0) {
                    if (this.subscribeObj[0].state === 1) {
                        this.status = 'active';
                    } else if (this.subscribeObj[0].state === 2) {
                        this.status = 'inacitve';
                    }
                } else {
                    this.status = 'trail';
                }
            }
        );
        this._teamProfileService.transectionDetail().subscribe(
            (res) => {
                this.invoiceObjdetail = res;
                this.invoiceObjdetails = this.invoiceObjdetail.data;
            }
        );
    }
    cancelSubscription() {
        let subscriptionId = {
            "subscriptionId": this.subscribeObj[0]._id
        };
        this._teamProfileService.cancelSubscription(subscriptionId).subscribe(
            (res) => {
                this.status = 'inacitve';
                $('#cancelSubscription').modal('hide');
            }
        )
    }

    reactivateSubscription() {
        let subscriptionId = {
            "subscriptionId": this.subscribeObj[0]._id
        };
        this._teamProfileService.reactivateSubscription(subscriptionId).subscribe(
            (res) => {
                    this.subscriptionDetail();
            }
        );
    }

    downloadPdf(invoiceObj){
        // let invoiceId:any = this.invoiceObjdetails[0]._id;
        this._teamProfileService.downlaodInvoicePdf(invoiceObj._id).subscribe(
            (res) => {
                saveAs(res, 'Invoice-' + invoiceObj.invoiceNo);
                console.log(res);
        })
    }

    checkForAnyUpdates() {
        // console.log(this.originalUserDetails, this.teamObj);
        if (
            this.oldTeamObj.name !== this.teamObj.name
            ||
            this.oldTeamObj.contact !== this.teamObj.contact ||
            this.oldTeamObj.websiteReferenceUrl !==
            this.teamObj.websiteReferenceUrl
        ) {
            return true;
        } else {
            return false;
        }
    }

    getTeamUpdate() {
        let obj: any = {};
        if (this.teamObj.contact !== this.oldTeamObj.contact) {
            obj.contact = this.teamObj.contact;
        }

        if (this.teamObj.name !== this.oldTeamObj.name) {
            obj.name = this.teamObj.name;
        }

        if (
            this.teamObj.websiteReferenceUrl !==
            this.oldTeamObj.websiteReferenceUrl
        ) {
            obj.websiteReferenceUrl = this.teamObj.websiteReferenceUrl;
        }
        console.log(obj);

        return obj;
    }
    updateNamesList(objDetails) {
        let updatedArray = [];
        let localStorageList = JSON.parse(localStorage.getItem('teams'));
        for (let entry of localStorageList){
           if(this.oldTeamObj.name === entry.teamDetails.name){
                entry.teamDetails.name = objDetails.name;
                updatedArray.push(entry);
           }else{
            updatedArray.push(entry);
           }
        }
        localStorage.setItem("teams", JSON.stringify(updatedArray));
    }
    updateTeamDetails() {
        if (!this.checkForAnyUpdates()) {
            return;
        }
        // console.log(this.checkForAnyUpdates());
        let objDetails = this.getTeamUpdate();

        if (this.teamObj) {
            this.originalUserDetails = this.teamObj ? this.teamObj : {};
            // this.originalUserDetails = _.clone(this.originalUserDetails);
        } else {
            this.originalUserDetails.userStatus = true;
        }
        console.log(this.originalUserDetails.name);

        // console.log(this.oldTeamObj);
        objDetails._id = this.teamObj._id;
        objDetails.isPreferenceUpdate = false;

        this._teamProfileService
            .updatingTeamDetails(objDetails, this.teamId)
            .subscribe(
                (result: any) => {
                    // console.log(objDetails);
                    // localStorage.setItem('teamName', this.teamName);
                    localStorage.setItem('teamName', this.teamObj.name);
                    this._landingComponent.updateTeamName();
                    this.updateNamesList(objDetails);
                    this.originalUserDetails._id = objDetails._id
                        ? objDetails._id
                        : this.originalUserDetails._id;
                    this.originalUserDetails.name = objDetails.name
                        ? objDetails.name
                        : this.originalUserDetails.name;
                    this.originalUserDetails.contact = objDetails.contact
                        ? objDetails.contact
                        : this.originalUserDetails.contact;
                    this.originalUserDetails.websiteReferenceUrl = objDetails.websiteReferenceUrl
                        ? objDetails.websiteReferenceUrl
                        : this.originalUserDetails.websiteReferenceUrl;
                    // if (this.successMsg == !this.successMsg) {
                    //     setTimeout(() => {
                    //         setTimeout(() => {
                    //             this.successMsg = false;
                    //         }, 1000);
                    //         this._router.navigateByUrl('./dashboard')
                    //     }, 3000);
                    // }
                },
                err => {
                    this.errMsg =
                        'The network connection has lost. Please try updating it again.';
                    setTimeout(() => {
                        this.errMsg = '';
                    }, 5000);
                }
            );
    }


    validateEmail(email) {
        let re = /^(([^<>()[\]\\.,;:\s@\']+(\.[^<>()[\]\\.,;:\s@\']+)*)|(\'.+\'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    onTagsChanged(event) {
        this.notificationEmailsError = false;
        this.notificationEmailDuplicateError = false;
        if (
            event.tag.displayValue &&
            !this.validateEmail(event.tag.displayValue)
        ) {
            let curEmail = this.notificationEmails[
                this.notificationEmails.length - 1
            ].displayValue;
            setTimeout(function () {
                $(
                    '#notificationEmails .tags-input__input-field'
                )[0].value = curEmail;
            }, 10);
            this.notificationEmails.pop();
            this.notificationEmailsError = true;
        }
        let emailArray = [];
        _.forEach(this.notificationEmails, function (email) {
            emailArray.push(_.values(email)[0]);
        });
        emailArray.pop();
        console.log(emailArray, event.tag.displayValue);
        if (event.tag.displayValue && emailArray.indexOf(event.tag.displayValue) >= 0) {
            this.notificationEmails.pop();
            this.notificationEmailDuplicateError = true;
            return;
        }
    }

    onTagsChangedInspectionNotifications(event) {
        this.inspectionNotificationEmailsError = false;
        this.inspectionNotificationEmailDuplicateError = false;
        if (
            event.tag.displayValue &&
            !this.validateEmail(event.tag.displayValue)
        ) {
            let curEmail = this.inspectionNotificationEmails[
                this.inspectionNotificationEmails.length - 1
            ].displayValue;
            setTimeout(function () {
                $(
                    '#inspectionNotificationEmails .tags-input__input-field'
                )[0].value = curEmail;
            }, 10);
            this.inspectionNotificationEmails.pop();
            this.inspectionNotificationEmailsError = true;
        }
        let emailArray = [];
        _.forEach(this.inspectionNotificationEmails, function (email) {
            emailArray.push(_.values(email)[0]);
        });
        emailArray.pop();
        console.log(emailArray, event.tag.displayValue);
        if (event.tag.displayValue && emailArray.indexOf(event.tag.displayValue) >= 0) {
            this.inspectionNotificationEmails.pop();
            this.inspectionNotificationEmailDuplicateError = true;
            return;
        }
    }

    onWeeklyEmailsChange(event) {
        this.weeklyNotificationEmailsError = false;
        this.weeklyNotificationEmailDuplicateError = false;
        if (
            event.tag.displayValue &&
            !this.validateEmail(event.tag.displayValue)
        ) {
            let curEmail = this.weeklyNotificationEmails[
                this.weeklyNotificationEmails.length - 1
            ].displayValue;
            setTimeout(function () {
                $(
                    '#weeklyNotificationEmails .tags-input__input-field'
                )[0].value = curEmail;
            }, 10);
            this.weeklyNotificationEmails.pop();
            this.weeklyNotificationEmailsError = true;
        }
        let emailArray = [];
        _.forEach(this.weeklyNotificationEmails, function (email) {
            emailArray.push(_.values(email)[0]);
        });
        emailArray.pop();
        console.log(emailArray, event.tag.displayValue);
        if (event.tag.displayValue && emailArray.indexOf(event.tag.displayValue) >= 0) {
            this.weeklyNotificationEmails.pop();
            this.weeklyNotificationEmailDuplicateError = true;
            return;
        }
    }


    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            } else if (control instanceof FormArray) {
                _.forEach(control.controls, (data: FormGroup) => {
                    this.validateAllFormFields(data);
                });
            }
        });
    }

    validateEmailBeforeInput(event) {
        this.notificationEmailsError = false;
        if (
            event.tag.displayValue &&
            !this.validateEmail(event.tag.displayValue)
        ) {
            let curEmail = this.notificationEmails[
                this.notificationEmails.length - 1
            ].displayValue;
            setTimeout(function () {
                $(
                    '#notificationEmails .tags-input__input-field'
                )[0].value = curEmail;
            }, 10);
            this.notificationEmails.pop();
            this.notificationEmailsError = true;
        }
    }

    // validateEmailBeforeInputNotification(event) {
    //     this.notificationEmailsHazardsError = false;
    //     if (
    //         event.tag.displayValue &&
    //         !this.validateEmail(event.tag.displayValue)
    //     ) {
    //         let curEmail = this.notificationEmailsHazards[
    //             this.notificationEmailsHazards.length - 1
    //         ].displayValue;
    //         setTimeout(function() {
    //             $(
    //                 '#notificationEmailsHazards .tags-input__input-field'
    //             )[0].value = curEmail;
    //         }, 10);
    //         this.notificationEmailsHazards.pop();
    //         this.notificationEmailsHazardsError = true;
    //     }
    // }


    updateEmailNotification() {
        let updatedNotificationEmails = _.map(this.notificationEmails, 'displayValue');
        let updatedInspectionNotificationEmails = _.map(this.inspectionNotificationEmails, 'displayValue');
        let updatedWeeklyNotificationEmails = _.map(this.weeklyNotificationEmails, 'displayValue');
        let updateObj = {
            _id: this.teamObj._id,
            hazardNotificationEmails: updatedNotificationEmails,
            inspectionNotificationEmails: updatedInspectionNotificationEmails,
            weeklyNotificationEmails: updatedWeeklyNotificationEmails,
            isPreferenceUpdate:  true
        };
        if (this.errorMsg || this.notificationEmailsError || this.notificationEmailDuplicateError) {
            return;
        }
        this._newTeamService.updateTeam(updateObj)
            .subscribe(
                (result) => {
                    this.temporaryEmailNotification = this.notificationEmails;
                    console.log('result ', result);
                    // this._router.navigateByUrl('/teamsList');
                },
                (err) => {
                    this.errMessage = err.error.message;
                }
            );
    }

    // openProfileImageUpload() {
    // console.log('hello world');
    // $('#imageUpload').modal('toggle');

    //     }
    //     fileChangeEvent(event: any): void {
    //         this.imageChangedEvent = event;
    //     }
    //     imageLoaded() {
    //         // show cropper
    //     }
    //     loadImageFailed() {
    //         // show message

    //     }
    //     saveImage() {
    //         this.saveImages =  this.croppedImage;
    //         // this.child.emit(this.saveImages);
    //         // console.log(this.child.emit(this.saveImages));
    //         // this.activeModal.dismiss();
    //     }
}



// WEBPACK FOOTER //
// ./src/app/team-profile/team-profile.component.ts